import React from 'react'
import { Card, CardHeader, CardTitle, CardBody, DataRow } from '../../../Card'
import { Badge } from '../../../../atoms/Badge'
import type { LandOwnersProps } from '../../LandSection.types'
import {
  OwnersGrid,
  OwnersList,
  OwnerItem,
  OwnerName,
  ClickableOwnerName,
  OwnerType,
} from './LandOwners.styles'

export const LandOwners: React.FC<LandOwnersProps> = ({
  owners,
  ownerCount,
  lastChangeDate,
  ownershipType,
  onOwnerClick,
  className,
  t,
}) => {
  const formatDate = (date?: string) => {
    if (!date) return t('common.notAvailable')
    try {
      return new Date(date).toLocaleDateString()
    } catch {
      return date
    }
  }

  const getOwnerTypeVariant = (
    type?: string
  ): 'success' | 'primary' | 'default' => {
    if (!type) return 'default'
    const lowerType = type.toLowerCase()
    if (lowerType.includes('private') || lowerType.includes('individual')) {
      return 'primary'
    }
    if (lowerType.includes('public') || lowerType.includes('institutional')) {
      return 'success'
    }
    return 'default'
  }

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{t('owners.title')}</CardTitle>
      </CardHeader>
      <CardBody>
        <OwnersGrid>
          <DataRow label={t('owners.number')} value={ownerCount} />

          {ownershipType && (
            <DataRow label={t('owners.ownershipType')} value={ownershipType} />
          )}

          {lastChangeDate && (
            <DataRow
              label={t('owners.lastChange')}
              value={formatDate(lastChangeDate)}
            />
          )}

          {owners && owners.length > 0 && (
            <DataRow
              label={t('owners.names')}
              value={
                <OwnersList>
                  {owners.map((owner, index) => (
                    <OwnerItem key={owner.id || `owner-${index}`}>
                      {onOwnerClick ? (
                        <ClickableOwnerName
                          onClick={() => onOwnerClick(owner.name)}
                        >
                          {owner.name}
                        </ClickableOwnerName>
                      ) : (
                        <OwnerName>{owner.name}</OwnerName>
                      )}
                      {owner.type && (
                        <OwnerType>
                          <Badge variant={getOwnerTypeVariant(owner.type)}>
                            {owner.type}
                          </Badge>
                        </OwnerType>
                      )}
                    </OwnerItem>
                  ))}
                </OwnersList>
              }
            />
          )}
        </OwnersGrid>
      </CardBody>
    </Card>
  )
}
